import {Component, HostListener, OnInit} from '@angular/core';
import {NewsService} from "../../services/news.service";
import {NavigationEnd, Router} from "@angular/router";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  menu:any=[{id:'',parend:'',titulo:'',childrens:[]}];
  wWidth:number=0;
  showStyle:boolean=false;
  class:any={ in: true};
  //mostrar:boolean=false;
  @HostListener('window:scroll', ['$event'])
  public onScrollEvent(event) {
    if(window.scrollY>140 && this.wWidth>1024){
      this.showStyle=true;
    }else{
      this.showStyle=false;
    }
  }
  @HostListener('window:resize', ['$event'])
  public onResizeEvent(event) {
      this.wWidth=event.target.screen.width;
      console.log(this.wWidth);
  }

  constructor(private news: NewsService, private _router: Router) {
    this.wWidth = window.screen.width;

  }

  ngOnInit() {
    this.news.getMenus().subscribe(response => {

      this.menu = response;
        console.log('MENUS', response);


      },
      error => {
        console.log(<any>error);
      });
    this._router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        console.log('_______>:', e);
        if(e.url!='/' && e.url!='/content/0'){
          this.class = {in: false};
        }

      }
    });
  }


}



// WEBPACK FOOTER //
// ./src/app/layouts/header/header.component.ts